import FullFieldsMap from "./map.categories[name].fields";

export const MASCULINE_CATEGORIES = {
  4: true,
  9: true,
  11: true,
  14: true,
  17: true,
  18: true,
  22: true,
  23: true,
};
const CHEAP_DAILY_PRICE_OPTIONS = {
  type: "radio",
  span: 2,
  operation: undefined,
  label: { ar: "السعر" },
  options: [
    {
      label: {
        ar: "500 ريال",
        en: "500  SAR",
      },
      value: { lte: 500 },
      path: "/500-ريال-يومي",
    },
    {
      label: {
        ar: "أكثر",
        en: "More",
      },
      value: { gt: 500 },
    },
  ],
};
const CATEGORY_PRICE_OVERRIDES = {
  3: {
    type: "radio",
    span: 2,
    operation: undefined,
    options: [
      {
        label: {
          ar: "أقل من 1.2 مليون",
          en: "less than 1.2M",
        },
        value: { lt: 1200000 },
        path: "/أقل-من-1.2-مليون",
      },
      {
        label: { ar: "أقل من 2 مليون", en: "less than 2M" },
        value: { gte: 1200000, lt: 2000000 },
        path: "/أقل-من-2-مليون",
      },
      {
        label: { ar: "أقل من 5 مليون", en: "less than 5M" },
        value: { gte: 2000000, lt: 5000000 },
        path: "/أقل-من-5-مليون",
      },
      {
        label: { ar: "فلل وقصور فاخرة", en: "fancy" },
        value: { gte: 5000000 },
        path: "/فلل-وقصور-فاخرة",
      },
    ],
  },
  23: CHEAP_DAILY_PRICE_OPTIONS,
  13: CHEAP_DAILY_PRICE_OPTIONS,
};
export const QuickFiltersFieldsUiSpec = (category) => ({
  rent_period: {
    ...FullFieldsMap.rent_period_,
    type: "radio",
    operation: "eq",
  },
  prices: {
    type: "prices",
    name: "prices",
    label: { ar: "الدفع " },
    span: 2,
    options: [
      {
        label: {
          ar: "دفعتين",
        },
        path: "/دفعتين",
        value: "price_2_payments",
      },
      {
        label: {
          ar: "4 دفعات",
        },
        value: "price_4_payments",
        path: "/4-دفعات",
      },
      {
        label: {
          ar: "شهري",
        },
        value: "price_12_payments",
        path: "/شهريا",
      },
    ],
    controls: [
      {
        operation: "gte",
        placeholder: { ar: "السعر الأدنى" },
        min: 1,
        max: 100000000,
        type: "number",
        positive: true,
        format: "currency",
      },
      {
        operation: "lte",
        placeholder: { ar: "السعر الأعلى" },
        min: 100,
        positive: true,
        format: "currency",

        max: 100000000,
        type: "number",
      },
    ],
  },
  family: {
    ...FullFieldsMap.family,
    type: "radio",
    operation: "eq",
  },
  beds: {
    ...FullFieldsMap.beds,
    type: "radio",
    operation: "eq",
    label: { ar: "الغرف" },
    options: [
      { label: { ar: "الكل", en: "any" }, value: undefined },
      {
        label: { ar: "غرفتين", en: "two bed rooms" },
        value: 2,
        path: "/غرفتين",
      },
      {
        label: { ar: "ثلاث غرف", en: "three bed rooms" },
        value: 3,
        path: "/ثلاث-غرف",
      },
      {
        label: { ar: "أربع غرف", en: "four bed rooms" },
        value: 4,
        path: "/أربع-غرف",
      },
      ...(`${category}` === "1"
        ? []
        : [
            {
              label: {
                ar: "خمس غرف",
                en: "5 bedrooms",
                alt: {
                  ar: "خمس غرف",
                  en: "5 bedrooms",
                },
              },
              value: { eq: 5 },
              matcher: "eq,5",
              path: "/خمس-غرف",
            },

            {
              label: {
                ar: "أكثر من 5 غرف",
                en: "more",
                alt: {
                  ar: "أكثر من 5 غرف",
                  en: "more than 5 bed rooms",
                },
              },
              value: { gt: 5 },
              matcher: "gt,5",
              path: "/أكثر-من-5-غرف",
            },
          ]),
    ],
  },
  livings: {
    ...FullFieldsMap.livings,
    type: "radio",
    operation: "gte",
    options: [
      { label: { ar: "أكثر من صالة" }, value: 1, path: "/أكثر-من-صالة" },
      { label: { ar: "أكثر من صالتين" }, value: 2, path: "/أكثر-من-صالتين" },
      { label: { ar: "أكثر من ٣ صالات" }, value: 3, path: "/أكثر-من-٣-صالات" },
    ],
  },
  wc: {
    ...FullFieldsMap.wc,
    type: "radio",
    operation: "gte",
  },
  furnished: {
    ...FullFieldsMap.furnished,
    switch: true,
    operation: "eq",
    type: "checkbox",
    path: "/مؤثثة",
  },
  car_entrance: {
    ...FullFieldsMap.car_entrance,
    switch: true,
    operation: "eq",
    type: "checkbox",
    path: "/مدخل-سيارة",
  },
  ac: {
    ...FullFieldsMap.ac,
    switch: true,
    operation: "eq",
    type: "checkbox",
    path: MASCULINE_CATEGORIES[category] ? "/مكيف" : "/مكيفة",
  },
  special_entrance: {
    ...FullFieldsMap.special_entrance,

    switch: true,
    operation: "eq",
    type: "checkbox",
    span: 1,
    path: "/مدخل-خاص",
  },
  two_entrances: {
    ...FullFieldsMap.two_entrances,
    switch: true,
    operation: "eq",
    type: "checkbox",
    span: 1,
    path: "/مدخلين",
  },
  private_roof: {
    ...FullFieldsMap.private_roof,
    switch: true,
    operation: "eq",
    type: "checkbox",
    span: 1,
    path: "/سطح-خاص",
  },
  apartment_in_villa: {
    ...FullFieldsMap.apartment_in_villa,
    operation: "eq",
    type: "checkbox",
    span: 1,
    switch: true,
    path: "/في-فيلا",
  },
  price: {
    ...FullFieldsMap.price,
    ...(CATEGORY_PRICE_OVERRIDES[category] || {
      type: "multiInput",
      span: 2,
      controls: [
        {
          operation: "gte",
          placeholder: { ar: "السعر الأدنى" },
          min: 100,
          max: 100000000,
          type: "number",
        },
        {
          operation: "lte",
          placeholder: { ar: "السعر الأعلى" },
          min: 100,
          type: "number",
          max: 100000000,
        },
      ],
    }),
  },
  fl: {
    ...FullFieldsMap.fl,
    operation: "eq",
    type: "radio",
    options: [
      ...(`${category}` === "1"
        ? [
            {
              label: { ar: "دور أرضي", en: "Ground floor" },
              path: "/دور-أرضي",
              value: 1,
            },
            {
              label: { ar: "دور أول", en: "Ground floor" },
              path: "/دور-أول",
              value: 2,
            },
          ]
        : [
            { label: { ar: "دور أرضي" }, value: 1, path: "/دور-أرضي" },
            { label: { ar: "دور علوي" }, value: 2, path: "/دور-أول" },
            { label: { ar: "الدور 3" }, value: 3, path: "/الدور-3" },
            { label: { ar: "الدور 4" }, value: 4, path: "/الدور-4" },
            {
              label: { ar: "الدور 5+" },
              value: { gte: 5 },
              path: "/الدور-5-وأكثر",
            },
          ]),
    ],
    max: 22,
    min: 1,
  },
  age: {
    ...FullFieldsMap.age,
    operation: "lte",
    type: "radio",
    min: 0,
    max: 10,
    value: 0,
    span: 1,
    options: [
      {
        label: { ar: "أقل من 2 سنة", en: "Less than 2 years" },
        value: 2,
        path: MASCULINE_CATEGORIES[category] ? "/جديد" : "/جديدة",
      },
      {
        label: { ar: "أقل من5 سنة", en: "Less than 5 years" },
        value: 5,
        path: "/أقل-من-5-سنة",
      },
      {
        label: {
          ar: "أقل من 10 سنة",
          en: "Less than 10 years",
          path: "/أقل-من-10-سنة",
        },
        value: 10,
      },
      {
        label: {
          ar: "أقل من 15 سنة",
          en: "Less than 15 years",
          path: "/أقل-من-15-سنة",
        },
        value: 15,
      },
    ],
  },
  type: {
    ...FullFieldsMap.type,
    operation: "eq",
    type: "radio",
  },
  meter_price: {
    ...FullFieldsMap.meter_price,
    operation: "lte",
    type: "radio",
    options: [
      {
        label: { ar: "أقل من 1500 ريال", en: "less than 1500 SAR" },
        value: 1500,
        path: "/أقل-من-1500-ريال-للمتر",
      },
      {
        label: {
          ar: "أقل من 3 آلاف ريال",
          en: "less than 3 thousand SAR",
        },
        value: 3000,
        path: "/أقل-من-3-آلاف-ريال-للمتر",
      },
      {
        label: {
          ar: "أقل من 10  آلاف ريال",
          en: "less than 10 thousand SAR",
        },
        path: "/أقل-من-10-آلاف-ريال-للمتر",
        value: 10000,
      },
      {
        label: {
          ar: "أقل من 20 ألف ريال",
          en: "less than 20 thousand SAR",
        },
        path: "/أقل-من-20-ألف-ريال-للمتر",
        value: 20000,
      },
      {
        label: {
          ar: "أكثر من 20 ألف ريال",
          en: "more than 20 thousand SAR",
        },
        path: "/أكثر-من-20-ألف-ريال-للمتر",
        value: { gte: 20000 },
        matcher: "gte,20000",
      },
    ],
  },
  area: {
    ...FullFieldsMap.area,
    type: "multiInput",
    span: 2,
    controls: [
      {
        operation: "gte",
        placeholder: { ar: "أقل مساحة" },
        min: 100,
        max: 100000000,
        type: "number",
      },
      {
        operation: "lte",
        placeholder: { ar: "أعلى مساحة" },
        min: 100,
        max: 100000000,
        type: "number",
      },
    ],
  },
  street_direction: {
    ...FullFieldsMap.street_direction,
    operation: "eq",
    type: "select",
  },
  street_width: {
    ...FullFieldsMap.street_width,
    operation: "gte",
    min: 5,
    max: 30,
    type: "radio",
    options: [
      {
        label: { ar: "أكثر من 5م", en: "more than 5m" },
        value: 5,
        path: "/عرض-الشارع-أكثر-من-5-متر",
      },
      {
        label: { ar: "أكثر من 10م", en: "more than 10m" },
        value: 10,
        path: "/عرض-الشارع-أكثر-من-10-متر",
      },
      {
        label: { ar: "أكثر من 15م", en: "more than 15m" },
        value: 15,
        path: "/عرض-الشارع-أكثر-من-15-متر",
      },
      {
        label: { ar: "أكثر من 20م", en: "more than 20m" },
        value: 20,
        path: "/عرض-الشارع-أكثر-من-20-متر",
      },
      {
        label: { ar: "أكثر من 30م", en: "more than 30m" },
        value: 30,
        path: "/عرض-الشارع-أكثر-من-30-متر",
      },
      {
        label: { ar: "أكثر من 50م", en: "more than 50m" },
        value: 50,
        path: "/عرض-الشارع-أكثر-من-50-متر",
      },
    ],
  },
  stairs: {
    ...FullFieldsMap.stairs,
    operation: "lte",
    type: "checkbox",
  },
  apts: {
    ...FullFieldsMap.apts,
    operation: "eq",
    type: "radio",
    options: [
      {
        label: { ar: "شقة واحدة", en: "one apartment" },
        value: 1,
        path: "/شقة-واحدة",
      },
      {
        label: { ar: "شقتان", en: "two apartments" },
        value: 2,
        path: "/شقتين",
      },
      {
        label: { ar: "٣ شقق", en: "three apartments" },
        value: 3,
        path: "/٣-شقق",
      },
      {
        label: { ar: "٤ شقق", en: "four apartments" },
        value: 4,
        path: "/٤-شقق",
      },
    ],
  },
  driver: {
    ...FullFieldsMap.driver,
    operation: "eq",
    type: "checkbox",
  },
  maid: {
    ...FullFieldsMap.maid,
    operation: "eq",
    type: "checkbox",
  },
  pool: {
    ...FullFieldsMap.pool,
    operation: "eq",
    type: "checkbox",
  },
  ketchen: {
    ...FullFieldsMap.ketchen,
    operation: "eq",
    type: "checkbox",
  },
  basement: {
    ...FullFieldsMap.basement,
    operation: "eq",
    type: "checkbox",
  },
  duplex: {
    ...FullFieldsMap.duplex,
    operation: "eq",
    type: "checkbox",
  },
  stores: {
    ...FullFieldsMap.stores,
    operation: "eq",
    type: "radio",
    options: [
      {
        label: { ar: "أقل من 4", en: "less than 4" },
        value: { lte: 4 },
        path: "/المحلات-أقل-من-4",
      },
      {
        label: { ar: "أكثر من 5", en: "more than 5" },
        value: { gte: 5 },
        path: "/المحلات-أكثر-من-5",
      },
    ],
  },
  tent: {
    ...FullFieldsMap.tent,
    operation: "eq",
    type: "checkbox",
  },
  family_section: {
    ...FullFieldsMap.family_section,
    operation: "eq",
    type: "checkbox",
  },
  fb: {
    ...FullFieldsMap.fb,
    operation: "eq",
    type: "checkbox",
  },
  vb: {
    ...FullFieldsMap.vb,
    operation: "eq",
    type: "checkbox",
  },
  playground: {
    ...FullFieldsMap.playground,
    operation: "eq",
    type: "checkbox",
  },
  extra_unit: {
    ...FullFieldsMap.extra_unit,
    operation: "eq",
    type: "checkbox",
  },
  villa_type: {
    ...FullFieldsMap.villa_type,
    type: "radio",
    operation: "eq",
  },
});
export default QuickFiltersFieldsUiSpec;
